<!--
 * @Author: liushumin
 * @Date: 2022-09-07 11:10:46
 * @LastEditTime: 2022-09-29 14:33:50
 * @LastEditors: liushumin
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div>
        <div class="szTitle">
          <p>{{ orderName }}</p>
          <div>
            <el-button
              size="medium"
              v-if="
                orderStatus == '10' ||
                orderStatus == '20' ||
                orderStatus == '30' ||
                orderStatus == '40'
              "
              @click="getCancelOrder"
              >取消订单</el-button
            >
            <el-button
              type="primary"
              size="medium"
              v-if="orderStatus == '10'"
              @click="confirmPricing"
              >确认定价</el-button
            >
            <!-- <el-button
              type="primary"
              size="medium"
              v-if="orderStatus == '20' || orderStatus == '30'"
              @click="confirmPayment(orderStatus)"
              >确认付款</el-button
            > -->
            <el-button
              type="primary"
              size="medium"
              v-if="orderStatus == '30'"
              @click="confirmPayment"
              >确认付款</el-button
            >
            <el-button
              type="primary"
              size="medium"
              v-if="orderStatus == '40'"
              @click="confirmDelivery"
              >发货</el-button
            >
            <el-button
              size="medium"
              v-if="orderStatus == '0'"
              @click="deleteOrder"
              >删除订单</el-button
            >
          </div>
        </div>

        <div class="order-status">
          <div class="left-side">
            <template>
              <img
                class="icon"
                v-if="orderStatus == '10'"
                src="../../../assets/szOrder/order_status_daiyijia@2x.png"
              />
              <img
                class="icon"
                v-if="orderStatus == '20'"
                src="../../../assets/szOrder/order_status_daifukuan@2x.png"
              />
              <img
                class="icon"
                v-if="orderStatus == '30'"
                src="../../../assets/szOrder/order_status_daifukuan@2x.png"
              />
              <img
                class="icon"
                v-if="orderStatus == '40'"
                src="../../../assets/szOrder/order_status_fahuo@2x.png"
              />
              <img
                class="icon"
                v-if="orderStatus == '50'"
                src="../../../assets/szOrder/order_status_shouhuo@2x.png"
              />
              <img
                class="icon"
                v-if="orderStatus == '60'"
                src="../../../assets/szOrder/order_status_end@2x.png"
              />
              <img
                class="icon"
                v-if="orderStatus == '0'"
                src="../../../assets/szOrder/order_status_clouse@2x.png"
              />
            </template>
            <p :class="orderStatus == '0' ? 'status-name-grey' : 'status-name'">
              {{ orderName }}
            </p>
          </div>
          <el-steps
            align-center
            finish-status="success"
            class="lightStep"
            v-if="orderStatus != '0'"
          >
            <el-step
              v-for="(item, index) in state_flow"
              :key="index"
              :title="item.name"
              :description="item.date"
              :status="item.is_choice == 'Y' ? 'success' : 'wait'"
            ></el-step>
          </el-steps>
          <el-steps
            align-center
            finish-status="success"
            class="greyStep"
            v-else
          >
            <el-step
              v-for="(item, inds) in state_cancel"
              :key="inds"
              :title="item.name"
              :description="item.date"
              :status="item.name != '订单关闭' ? 'success' : 'error'"
            >
              <template slot="description">
                <span v-if="item.name != '订单关闭'">{{ item.date }}</span>
                <p v-else>
                  <span>{{ item.date }}</span
                  ><br /><span class="desErrorText"
                    >取消原因：{{ item.remark }}</span
                  >
                </p>
              </template>
            </el-step>
          </el-steps>
        </div>
        <div class="title-wrap">
          <div class="title">基本信息</div>
        </div>
        <el-table :data="infoOrder" border style="width: 100%">
          <el-table-column
            prop="orderNum"
            label="订单编号"
            min-width="20%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="receiver"
            label="买家"
            min-width="20%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="expectedTime"
            label="期望取货时间"
            min-width="20%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="orderSource"
            label="订单来源"
            min-width="18%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="types"
            label="下单方式"
            min-width="18%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.types | filterOrderStatus }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="payStatus"
            label="支付方式"
            min-width="15%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.payStatus | filterPayStatus }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 修改发票id为null 时隐藏修改入口 -->
        <div class="title-wrap" v-if="invoicesInfo && invoicesInfo.id != null">
          <div class="title">发票信息</div>
          <p
            v-if="
              orderStatus == '10' ||
              orderStatus == '20' ||
              orderStatus == '30' ||
              orderStatus == '40'
            "
            @click="checkFp"
          >
            <img src="../../../assets/szOrder/icon_bianji@2x.png" alt="" />
            <span>修改发票信息</span>
          </p>
        </div>
        <el-table
          v-if="invoicesInfo.id != null"
          :data="infoFp"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="billTypes"
            label="发票类型"
            min-width="18%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="发票抬头"
            min-width="30%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.status | fpStatusFn
            }}</template>
          </el-table-column>
          <el-table-column
            v-if="fpStatus == '0'"
            prop="billTitle"
            label="发票内容"
            min-width="30%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
            <template slot-scope="scope"
              >抬头：{{ scope.row.billTitle }}</template
            >
          </el-table-column>
          <el-table-column
            v-if="fpStatus == '1'"
            prop="billInfo"
            label="发票内容"
            min-width="30%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="height: 140px; display: flex; flex-direction: column">
                <span>抬头：{{ scope.row.billTitle }}</span>
                <span>纳税人识别号: {{ scope.row.socialCreditCode }}</span>
                <span>公司地址：{{ scope.row.address }}</span>
                <span>公司电话：{{ scope.row.telephone }}</span>
                <span>开户行：{{ scope.row.bankName }}</span>
                <span>银行账号：{{ scope.row.accountNum }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="payeeMsg"
            label="收票人信息"
            min-width="20%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.payeeTel }}</span
              ><br /><span>{{ scope.row.payeeMailbox }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="title-wrap">
          <div class="title">收货人信息</div>
          <p
            v-if="
              orderStatus == '10' ||
              orderStatus == '20' ||
              orderStatus == '30' ||
              orderStatus == '40'
            "
            @click="getEditHavest"
          >
            <img src="../../../assets/szOrder/icon_bianji@2x.png" alt="" />
            <span>修改收货人信息</span>
          </p>
        </div>
        <el-table :data="infoSh" border style="width: 100%">
          <el-table-column
            prop="receiver"
            label="收货人"
            min-width="18%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="telphone"
            label="手机号码"
            min-width="31%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column
            prop="contacts"
            label="邮政编码"
            min-width="32%"
            align="center"
            :resizable="false"
          >
          </el-table-column> -->
          <el-table-column
            prop="addr"
            label="收获地址"
            min-width="46%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <div class="title-wrap">
          <div class="title">商品信息</div>
          <p v-if="orderStatus == '10'" @click="getEditGoods">
            <img src="../../../assets/szOrder/icon_bianji@2x.png" alt="" />
            <span>修改商品信息</span>
          </p>
        </div>
        <el-table :data="infoGoods" border style="width: 100%">
          <el-table-column
            prop="goodsImg"
            label="商品图片"
            min-width="20%"
            align="center"
            :resizable="false"
          >
            <template slot-scope="scope">
              <!-- <img
                :src="scope.row.goodsImg"
                style="width: 120px; height: 120px"
              /> -->
              <el-image
                style="width: 120px; height: 120px"
                :src="scope.row.goodsImg"
                :preview-src-list="
                  scope.row.goodsImg
                    ? scope.row.goodsImg.split(',')
                    : scope.row.goodsImg
                "
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="goodsName"
            label="商品名称"
            min-width="20%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="goodsPrice"
            label="价格"
            min-width="20%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="goodsAttribute"
            label="属性"
            min-width="15%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="goodsNum"
            label="数量"
            min-width="15%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="totalPay"
            label="小计"
            min-width="15%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <div class="title-wrap">
          <div class="title">费用信息</div>
          <p v-if="orderStatus == '10'" @click="getEditCost">
            <img src="../../../assets/szOrder/icon_bianji@2x.png" alt="" />
            <span>修改费用信息</span>
          </p>
        </div>
        <el-table :data="infoFare" border style="width: 100%">
          <el-table-column
            prop="totalPay"
            label="商品合计"
            min-width="20%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="freightMoney"
            label="运费"
            min-width="20%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="discountPrices"
            label="优惠"
            min-width="20%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="oredrPrice"
            label="订单总金额"
            min-width="18%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="remitMoneyPrice"
            label="应付款金额"
            min-width="18%"
            align="center"
            :resizable="false"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <div
          v-if="
            orderStatus == '30' ||
            orderStatus == '40' ||
            orderStatus == '50' ||
            orderStatus == '60'
          "
        >
          <div class="title-wrap">
            <div class="title">付款信息</div>
            <!-- <p>
              <img src="../../../assets/szOrder/icon_bianji@2x.png" alt="" />
              <span>修改付款信息</span>
            </p> -->
          </div>
          <el-table :data="infoPayment" border style="width: 100%">
            <el-table-column
              prop="createTime"
              label="提交时间"
              min-width="20%"
              align="center"
              :resizable="false"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注信息"
              min-width="20%"
              align="center"
              :resizable="false"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="imgUrl"
              label="汇款凭证"
              min-width="20%"
              align="center"
              :resizable="false"
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.imgUrl != '' && scope.row.imgUrl != undefined"
                  style="display: flex; flex-wrap: wrap"
                >
                  <!-- <div v-for="(imgs, ind) in scope.row.imgUrl" :key="ind">
                    <img :src="imgs" alt="" style="width: 60px; height: 60px; margin-right: 10px;" />
                  </div> -->
                  <el-image
                    v-for="(imgs, ind) in scope.row.imgUrl"
                    :key="ind"
                    style="width: 60px; height: 60px; margin-right: 10px"
                    :src="imgs"
                    :preview-src-list="scope.row.imgUrl"
                  >
                  </el-image>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="orderStatus == '50' || orderStatus == '60'">
          <div class="title-wrap">
            <div class="title">物流信息</div>
          </div>
          <el-table :data="infoWlment" border style="width: 100%">
            <el-table-column
              prop="saleOrderTime"
              label="发货时间"
              min-width="20%"
              align="center"
              :resizable="false"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="contacts"
              label="承运对象"
              min-width="20%"
              align="center"
              :resizable="false"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="telPhone"
              label="联系方式"
              min-width="20%"
              align="center"
              :resizable="false"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注信息"
              min-width="20%"
              align="center"
              :resizable="false"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="title-wrap" v-if="false">
          <div class="title">操作信息</div>
          <p
            v-if="
              orderStatus == '10' ||
              orderStatus == '20' ||
              orderStatus == '30' ||
              orderStatus == '40' ||
              orderStatus == '50' ||
              orderStatus == '60' ||
              orderStatus == '0'
            "
            @click="getEditRemark"
          >
            <img src="../../../assets/szOrder/icon_bianji@2x.png" alt="" />
            <span>修改备注信息</span>
          </p>
        </div>
        <el-table :data="infoOperate" border style="width: 100%" v-if="false">
          <el-table-column
            prop="saleOrderTime"
            label="操作者"
            min-width="20%"
            align="center"
            :resizable="false"
          >
          </el-table-column>
          <el-table-column
            prop="remark"
            label="操作时间"
            min-width="20%"
            align="center"
            :resizable="false"
          >
          </el-table-column>
          <el-table-column
            prop="contacts"
            label="订单状态"
            min-width="20%"
            align="center"
            :resizable="false"
          >
          </el-table-column>
          <el-table-column
            prop="telPhone"
            label="议价状态"
            min-width="15%"
            align="center"
            :resizable="false"
          >
          </el-table-column>
          <el-table-column
            prop="orderBuy"
            label="付款状态"
            min-width="15%"
            align="center"
            :resizable="false"
          >
          </el-table-column>
          <el-table-column
            prop="payOrder"
            label="发货状态"
            min-width="15%"
            align="center"
            :resizable="false"
          >
          </el-table-column>
          <el-table-column
            prop="note"
            label="备注"
            min-width="15%"
            align="center"
            :resizable="false"
          >
          </el-table-column>
        </el-table>
      </div>
      <!-- 修改发票信息弹框 -->
      <!-- @cancelStatus="getCancelStatus" -->
      <EditFare
        :openStatus="fareStatus"
        :infoFpObj="infoFp[0]"
        :orderId="orderId"
        @closeStatus="getCloseStatus"
      >
      </EditFare>

      <!-- 修改收货人信息弹框 -->
      <EditHavest
        :openStatus="havestStatus"
        :infoShObj="infoSh[0]"
        :orderId="orderId"
        @closeStatus="getCloseStatus"
      >
      </EditHavest>

      <!-- 订单备注弹框 -->
      <remarkDialog
        :openStatus="remarkStatus"
        @closeStatus="getCloseStatus"
      ></remarkDialog>

      <!-- 取消订单弹框 -->
      <cancelDialog
        :openStatus="checkStatus"
        :orderId="orderId"
        @closeStatus="getCloseStatus"
      ></cancelDialog>

      <!-- 修改费用信息  -->
      <EditCost
        :openStatus="costStatus"
        :infoFareInfo="infoFares"
        :orderId="orderId"
        @closeStatus="getCloseStatus"
      >
      </EditCost>

      <!-- 发货 -->
      <SendGoods
        :openStatus="sendStatus"
        :orderId="orderId"
        @closeSendStatus="getCloseSendStatus"
      ></SendGoods>

      <!-- 确定定价弹框 -->
      <el-dialog
        class="dialog-bg dialog-confirm-account"
        title="确认提示"
        :visible.sync="showDialogPrice"
        width="420px"
      >
        <div class="text">是否确认已经定价完成？</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showDialogPrice = false">取消</el-button>
          <el-button type="primary" @click="confirmPrice">确认</el-button>
        </span>
      </el-dialog>

      <!-- 付款核实弹框 -->
      <el-dialog
        class="dialog-bg dialog-confirm-account"
        title="确认提示"
        :visible.sync="showDialogPayment"
        width="420px"
      >
        <div class="text">是否确认已经核实付款？</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showDialogPayment = false">取消</el-button>
          <el-button type="primary" @click="confirmPaymentBtn">确认</el-button>
        </span>
      </el-dialog>

      <!-- 删除订单弹框 -->
      <el-dialog
        class="dialog-bg dialog-confirm-account"
        title="确认提示"
        :visible.sync="showDialogDelete"
        width="420px"
      >
        <div class="text">是否确认删除订单？</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showDialogDelete = false">取消</el-button>
          <el-button type="primary" @click="confirmDelete">确认</el-button>
        </span>
      </el-dialog>
    </div>
  </el-main>
</template>
<script>
import EditFare from "./OrderPop/EditFare.vue";
import EditHavest from "./OrderPop/EditHavest.vue";
import remarkDialog from "./OrderPop/Remark.vue";
import cancelDialog from "./OrderPop/CancelOrder.vue";
import EditCost from "./OrderPop/EditCost.vue";
import SendGoods from "./OrderPop/SendGoods.vue";
export default {
  data() {
    return {
      msg: {
        releaseTime: "2017-07-19 15:43:23",
        meetTime: "未议价",
        taskStart: "",
        taskEnd: "",
        paymentTime: "",
        payment: "",
      },
      infoOrder: [
        {
          orderNum: "",
          receiver: "",
          createTime: "",
          orderSource: "",
          types: "",
          payStatus: "",
          expectedTime:''
        },
      ],
      infoPayment: [
        {
          createTime: "",
          remark: "",
          imgUrl: [],
        },
      ],
      infoWlment: [
        {
          saleOrderTime: "",
          remark: "",
          contacts: "",
          telPhone: "",
        },
      ],
      infoGoods: [
        {
          goodsImg: "",
          goodsName: "",
          goodsPrice: "",
          goodsAttribute: "",
          goodsNum: "",
          totalPay: "",
        },
      ],

      infoFare: [
        {
          totalPay: "",
          freightMoney: "",
          discountPrices: "",
          oredrPrice: "",
          remitMoneyPrice: "",
          id: "",
        },
      ],
      infoFares: [],
      infoOperate: [
        {
          saleOrderTime: "201707196398345",
          remark: "张三合作社",
          contacts: "2022-10-10",
          telPhone: "合作社",
          orderBuy: "自主下单",
          payOrder: "线下全款",
          note: "备注",
        },
      ],
      infoFp: [
        {
          billTypes: "",
          billTitle: "",
          billInfo: "",
          // payeeMsg: "",
          payeeTel: "",
          payeeMailbox: "",
          status: "",
          id: "",
          billTitle: "",
          socialCreditCode: "",
          address: "",
          telephone: "",
          bankName: "",
          accountNum: "",
        },
      ],
      infoSh: [
        {
          receiver: "",
          telphone: "",
          addr: "",
        },
      ],
      state_flow: [],
      // state_cancel: [
      //   { name: "提交订单", date: "2022-07-14 09:39:55", is_choice: "Y" },
      //   {
      //     name: "关闭",
      //     date: "2022-07-14 09:39:55",
      //     is_choice: "N",
      //     reason: "取消原因：重复下单/误下单",
      //   },
      // ],
      state_cancel: [],
      orderStatus: "",
      orderName: "",
      fareStatus: "",
      havestStatus: false,
      remarkStatus: false,
      checkStatus: false,
      costStatus: false,
      orderId: "",
      goodsInfo: {},
      invoicesInfo: {},
      orderInfo: {},
      payListInfo: {},
      payInfo: {},
      payImgInfo: {},
      sendStatus: false,
      fpStatus: "",
      infoWlmentInfo: {},
      showDialogPrice: false,
      showDialogPayment: false,
      showDialogDelete: false,
      infoFpObj: {},
    };
  },
  components: {
    EditFare,
    EditHavest,
    remarkDialog,
    cancelDialog,
    EditCost,
    SendGoods,
  },
  filters: {
    filterPayStatus(val) {
      if (val == 10) {
        return "线下";
      } else if (val == 20) {
        return "贷款";
      } else if (val == 30) {
        return "部分贷款";
      } else if (val == 40) {
        return "银行转账";
      } else if (val == "") {
        return "暂无";
      }
    },
    filterOrderStatus(val) {
      if (val == 0) {
        return "自主下单";
      } else if (val == 1) {
        return "运营后台下单";
      }
    },
    fpStatusFn(val) {
      if (val == 0) {
        return "个人";
      } else if (val == 1) {
        return "单位";
      }
    },
  },
  created() {
    this.orderStatus = this.$route.query.orderStatus;
    this.orderId = this.$route.query.id;
    if (this.orderStatus == "10") {
      this.orderName = "待议价";
    } else if (this.orderStatus == "20") {
      this.orderName = "待付款";
    } else if (this.orderStatus == "30") {
      this.orderName = "待确认付款";
    } else if (this.orderStatus == "40") {
      this.orderName = "待发货";
    } else if (this.orderStatus == "50") {
      this.orderName = "已发货";
    } else if (this.orderStatus == "60") {
      this.orderName = "已完成";
    } else if (this.orderStatus == "0") {
      this.orderName = "已取消";
    }
  },
  mounted() {
    // let targetFlag = this.$route.query.flag;
    // if (targetFlag == 1) {
    //   this.$route.meta.targetPath = "/szoperation/order/list";
    // } else if (targetFlag == 2) {
    //   this.$route.meta.targetPath = "/szoperation/order/bargain";
    // } else if (targetFlag == 3) {
    //   this.$route.meta.targetPath = "/szoperation/order/payment";
    // } else if (targetFlag == 4) {
    //   this.$route.meta.targetPath = "/szoperation/order/deliver";
    // } else if (targetFlag == 5) {
    //   this.$route.meta.targetPath = "/szoperation/order/harvest";
    // }
    this.getGoodsInfo();
  },
  methods: {
    // 获取订单详情接口
    getGoodsInfo() {
      this.fpStatus = "";
      this.$http.szOrder
        .getOrder({
          orderId: this.orderId,
        })
        .then((res) => {
          if (res.status == 1) {
            let goodsData = res.data;
            this.goodsInfo = goodsData.goods;
            this.invoicesInfo = goodsData.invoices;
            this.orderInfo = goodsData.order;
            this.payListInfo = goodsData.payList;
            this.payInfo = goodsData.pay;
            this.payImgInfo = goodsData.payImg;
            this.infoWlmentInfo = goodsData.delivery;

            // 订单流程
            this.state_flow = goodsData.flowsheet;
            this.state_cancel = goodsData.flowsheet;

            // 发票信息
            if (this.invoicesInfo != null) {
              this.infoFp[0].billTypes = this.invoicesInfo.billTypes;
              this.infoFp[0].billTitle = this.invoicesInfo.billTitle;
              this.infoFp[0].billInfo = this.invoicesInfo.billInfo;
              this.invoicesInfo.payeeTel =
                this.invoicesInfo.payeeTel != null
                  ? this.invoicesInfo.payeeTel
                  : "";
              this.invoicesInfo.payeeMailbox =
                this.invoicesInfo.payeeMailbox != null
                  ? this.invoicesInfo.payeeMailbox
                  : "";
              // this.infoFp[0].payeeMsg =
              //   this.invoicesInfo.payeeTel +
              //   " " +
              //   this.invoicesInfo.payeeMailbox;
              this.infoFp[0].payeeTel = this.invoicesInfo.payeeTel;
              this.infoFp[0].payeeMailbox = this.invoicesInfo.payeeMailbox;
              this.infoFp[0].status = this.invoicesInfo.status;
              this.fpStatus = this.invoicesInfo.status;
              this.infoFp[0].id = this.invoicesInfo.id;
              this.infoFp[0].billTitle = this.invoicesInfo.billTitle;
              this.infoFp[0].socialCreditCode =
                this.invoicesInfo.socialCreditCode;
              this.infoFp[0].address = this.invoicesInfo.address;
              this.infoFp[0].telephone = this.invoicesInfo.telephone;
              this.infoFp[0].bankName = this.invoicesInfo.bankName;
              this.infoFp[0].accountNum = this.invoicesInfo.accountNum;
              // sessionStorage.setItem("infoFpObj", JSON.stringify(this.infoFp));

              // this.$store.state.szStatus.szFareDetails = this.infoFp[0];
            } else {
              this.infoFp = [];
            }

            // 物流信息
            if (this.infoWlmentInfo != null) {
              this.infoWlment[0].saleOrderTime =
                this.infoWlmentInfo.saleOrderTime;
              this.infoWlment[0].contacts = this.infoWlmentInfo.contacts;
              this.infoWlment[0].telPhone = this.infoWlmentInfo.telPhone;
              this.infoWlment[0].remark = this.infoWlmentInfo.remark;
            } else {
              this.infoWlment = [];
            }

            //订单基本信息
            if (this.orderInfo != null) {
              this.infoOrder[0].orderNum = this.orderInfo.orderNum;
              this.infoOrder[0].receiver = this.orderInfo.receiver;
              this.infoOrder[0].createTime = this.orderInfo.createTime;
              this.infoOrder[0].orderSource = this.orderInfo.orderSource;
              this.infoOrder[0].expectedTime = this.orderInfo.expectedTime;
              this.infoOrder[0].types = this.orderInfo.types;
              this.infoOrder[0].payStatus =
                this.pay != null && this.pay ? this.pay.status : "";

              // 收货人信息
              this.infoSh[0].receiver = this.orderInfo.receiver;
              this.infoSh[0].telphone = this.orderInfo.telphone;
              this.infoSh[0].addr = this.orderInfo.addr;
              this.$store.state.szStatus.receiverObj = this.infoSh[0];
              // sessionStorage.setItem("infoShObj", JSON.stringify(this.infoSh));
            } else {
              this.infoOrder = [];
              this.infoSh = [];
            }

            // 商品信息
            if (this.goodsInfo != null) {
              this.infoGoods[0].goodsImg = this.goodsInfo.goodsImg;
              this.infoGoods[0].goodsName = this.goodsInfo.goodsName;
              this.infoGoods[0].goodsPrice = this.goodsInfo.goodsPrice;
              this.infoGoods[0].goodsAttribute = this.goodsInfo.goodsAttribute;
              this.infoGoods[0].goodsNum = this.goodsInfo.goodsNum;
              this.infoGoods[0].totalPay = this.goodsInfo.totalPay;
            } else {
              this.infoGoods = [];
            }

            // 费用信息
            if (this.payInfo != null) {
              // this.infoFare[0].totalPay = this.payInfo.totalPay;
              this.infoFare[0].totalPay =
                this.goodsInfo != null ? this.goodsInfo.totalPay : "";
              this.infoFare[0].freightMoney = this.payInfo.freightMoney;
              this.infoFare[0].discountPrices = this.payInfo.discountPrices;
              this.infoFare[0].oredrPrice = this.payInfo.oredrPrice;
              this.infoFare[0].remitMoneyPrice = this.payInfo.remitMoneyPrice;
              this.infoFare[0].id = this.payInfo.id;
              this.$store.state.szStatus.szDetailsObj = this.infoFare;
            } else {
              this.infoFare = [];
            }

            // 付款信息
            if (
              this.payImgInfo != null &&
              Object.keys(this.payImgInfo).length != 0
            ) {
              this.infoPayment[0].createTime = this.payImgInfo.createTime;
              this.infoPayment[0].remark = this.payImgInfo.remark;
              this.infoPayment[0].imgUrl = this.payImgInfo.imgUrl;
            } else {
              this.infoPayment = [];
            }
            console.log(this.infoPayment);
          }
        });
    },

    // 确认定价
    confirmPricing() {
      this.showDialogPrice = true;
    },
    confirmPrice() {
      this.$http.szOrder
        .confirmPricing({
          orderId: this.orderId,
        })
        .then((res) => {
          if (res.status == 1) {
            this.$message({
              message: "确定成功",
              type: "success",
              duration: 3000,
            });
            this.showDialogPrice = false;
            this.orderStatus = 20;
            this.getGoodsInfo();
          }
        });
    },

    // 确认付款
    confirmPayment() {
      this.showDialogPayment = true;
    },
    confirmPaymentBtn() {
      this.$http.szOrder
        .confirmPayment({
          orderId: this.orderId,
        })
        .then((res) => {
          if (res.status == 1) {
            this.$message({
              message: "付款核实成功",
              type: "success",
              duration: 3000,
            });
            this.showDialogPayment = false;
            this.getGoodsInfo();
            this.orderStatus = 40;
          }
        });
    },

    // 确认发货
    confirmDelivery() {
      this.sendStatus = true;
    },

    // 删除订单
    deleteOrder() {
      this.showDialogDelete = true;
    },
    confirmDelete() {
      this.$http.szOrder
        .deleteOrder({
          orderId: this.orderId,
        })
        .then((res) => {
          if (res.status == 1) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.showDialogDelete = false;
            this.$router.push({ path: "/szoperation/order/list" });
          }
        });
    },
    // 修改发票信息
    checkFp() {
      this.fareStatus = true;
      this.infoFpObj = this.infoFp[0];
      this.$store.state.szStatus.szFareDetails = this.infoFpObj;
    },
    // 修改收货人信息
    getEditHavest() {
      this.havestStatus = true;
      this.infoFares = this.$store.state.szStatus.receiverObj;
      sessionStorage.setItem("orderId", this.orderId);
      console.log(this.infoFares);
      console.log(this.orderId);
    },
    // 修改备注信息
    getEditRemark() {
      this.remarkStatus = true;
    },
    // 修改商品信息
    getEditGoods() {
      sessionStorage.setItem("infoGoods", JSON.stringify(this.infoGoods));
      this.$router.push({
        path: "/szoperation/order/mendProdect",
        query: {
          // infoGoods: JSON.stringify(this.infoGoods),
          orderId: this.orderId,
        },
      });
    },
    // 修改费用信息
    getEditCost() {
      this.costStatus = true;
      this.infoFares = this.$store.state.szStatus.szDetailsObj;
      // sessionStorage.setItem("infoFareInfo", JSON.stringify(this.infoFare));
    },
    //取消订单
    getCancelOrder() {
      this.checkStatus = true;
    },
    getCloseStatus(val) {
      if (val == true) {
        this.fareStatus = false;
        this.havestStatus = false;
        this.remarkStatus = false;
        this.checkStatus = false;
        this.costStatus = false;
        this.getGoodsInfo();
      }
    },
    getCloseSendStatus(val) {
      if (val == true) {
        this.sendStatus = false;
        this.orderStatus = 50;
        this.getGoodsInfo();
      }
    },
    // getCancelStatus(val) {
    //   if (val == true) {
    //     // 调列表接口
    //     this.getGoodsInfo();
    //   }
    // },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../styles/order-global.scss";

.order-details-step {
  width: 80%;
  margin: 0 auto;
}

.order-details-status {
  display: flex;
  margin-top: 20px;
  justify-content: center;
}

.order-details-status p {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
}

.order-details-status p span {
  margin: 10px 0;
}

.title {
  margin: 10px 0 10px 0;
  font-size: 18px;
  color: #333333;
  display: flex;
  align-items: center;
  font-weight: bold;

  label {
    font-size: 16px;
    color: #999999;
  }

  &:before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 18px;
    background: #018388;
    border-radius: 3px;
    margin-right: 5px;
  }
}

.title-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-wrap img {
  width: 16px;
  height: 16px;
  display: inline-block;
  margin-right: 6px;
}

.title-wrap p {
  font-size: 16px;
  font-weight: 500;
  color: #048489;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.order-status {
  display: flex;
  align-items: center;
  padding: 20px 0;

  .left-side {
    padding: 0 70px 0 30px;
    border-right: 1px solid #e7e7e7;
    text-align: center;

    .icon {
      height: 55px;
    }

    .status-name {
      font-size: 20px;
      color: #018388;
      font-weight: bold;
      margin-top: 6px;
    }

    .status-name-grey {
      font-size: 20px;
      color: #888888;
      font-weight: bold;
      margin-top: 6px;
    }
  }

  .lightStep {
    flex-grow: 1;
    max-width: 1150px;
    margin: 0 auto;
  }

  .greyStep {
    flex-grow: 1;
    max-width: 650px;
    margin: 0 auto;
  }

  .desErrorText {
    font-size: 16px;
    font-weight: 400;
    color: #f20000;
  }
}
</style>
